<template>
  <b-card>
      <Snapshot
    :is-snap-shot-sidebar-active.sync="isSnapShotSidebarActive"
    :user-data="userData"
    user-type="STAFF"
    @clicked="one"
  />
    <!-- Alert: No item found -->
    <b-tabs>
      <!-- Tab: Account -->
      <b-tab active>
        <template #title>
          <feather-icon
            icon="UserIcon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">Account</span>
        </template>
        <div>

          <!-- Header: Personal Info -->
          <div class="d-flex">
            <feather-icon
              icon="UserIcon"
              size="19"
            />
            <h4 class="mb-0 ml-50">
              Personal Information
            </h4>
          </div>
          <b-row>
              <b-col md="8" lg="9">
          <!-- Form: Personal Info Form -->
          <b-form class="mt-1">
            <b-row>

              <!-- Field: Mobile -->
              <b-col
                cols="12"
                md="6"
                lg="3"
              >
                <b-form-group
                  label="Display Name"
                  label-for="display_name"
                >
                  <b-form-input
                    id="display_name"
                    v-model="userData.display_name"
                  />
                </b-form-group>
              </b-col>
              
              <b-col
                cols="12"
                md="6"
                lg="3"
              >
                <b-form-group
                  label="Username"
                  label-for="username"
                >
                  <b-form-input
                    id="username"
                    v-model="userData.username"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="3"
              >
                <b-form-group
                  label="Status"
                  label-for="status"
                >
                  <v-select
                    v-model="userData.status"
                    :reduce="option => option.value"
                    :options="statusOptions"
                    :clearable="false"
                    input-id="status"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="3"
              >
                <b-form-group
                  label="Mobile"
                  label-for="Mobile"
                >
                  <b-form-input
                    id="mobile"
                    v-model="userData.mobile"
                  />
                </b-form-group>
              </b-col>
              <!-- <b-col
                cols="12"
                md="6"
                lg="3"
              >
                <b-form-group
                  label="Role"
                  label-for="role"
                >
                  <v-select
                    v-model="userData.role"
                    :reduce="ans => ans.value"
                    :options="roleOptions"
                    :clearable="false"
                    input-id="role"
                  />
                </b-form-group>
              </b-col> -->
              <b-col
                cols="12"
                md="6"
                lg="3"
              >
                <b-form-group
                  label="Group"
                  label-for="Group"
                >
                  <v-select
                    v-model="userData.group_id"
                    :reduce="ans => ans.id"
                    label="name"
                    :options="groupOptions"
                    :clearable="false"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="3"
              >
                <b-form-group
                  label="Entry Reocrd"
                  label-for="entry_record"
                >
                  <v-select
                    v-model="userData.entry_record"

                    :options="['Y','N']"
                    :clearable="false"
                    input-id="entry_record"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="3"
              > 
                <b-form-group
                  label="Default Login Centers"
                  label-for="default_center_id"
                >
                  <v-select
                    v-model="userData.default_center_id"
                    label="label"
                    :reduce="c => c.value"
                    :options="centerOptions"
                    :clearable="false"
                    input-id="default_center_id"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="6"
              >
                <b-form-group
                  label="Access Centers"
                  label-for="access_centers"
                >
                  <v-select
                    v-model="userData.access_center"

                    :options="centerOptions"
                    :clearable="false"
                    multiple
                    input-id="access_center"
                  />
                </b-form-group>
              </b-col>
              
             
              
            </b-row>
            
            <b-row class="mt-2">
              <b-col>
                <b-button
                  variant="primary"
                  class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  @click="save_staff"
                >
                  Save Changes
                </b-button>
                <b-button
                  variant="outline-secondary"
                  class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  :to="{ name: 'staff-list' }"
                >
                  Cancel
                </b-button>
                <b-button
                  variant="danger"
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  @click="reset_password"
                >
                  Reset Password
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-col>
        <b-col md="4" lg="3">
            <img
              style="width:100%;border-radius:10px;"
              ref="previewEl"
              @error="userData.avatar = ''"
              :src="userData.avatar"
              size="100%"
              rounded
            /><br>
            <!-- <b-button
              class="mt-1"
              block
              variant="primary"
              @click="go()"
            >
            <feather-icon icon="CameraIcon" />
             <span> {{ $t('Start Camera') }} </span>
            </b-button> -->

            <b-button
            class="mt-1"
            block
            variant="primary"
            @click="snapshot2()"
          >
          <feather-icon icon="CameraIcon" />
           <span> {{ $t('Start Camera') }} </span>
          </b-button>


            <!-- <b-button
              class="mt-1"
              block
              variant="outline-primary"
              @click="update_card()"
            >
            <feather-icon icon="RssIcon" />
            <span  v-if="userData.card_id"> {{ $t('Update Card') }} </span>
            <span  v-if="!userData.card_id"> {{ $t('Register Card') }} </span>
            </b-button> -->
 
        </b-col>
      </b-row>
        </div>
      </b-tab>
      
      <b-tab>
        <template #title>
          <feather-icon
            icon="LogInIcon"
            size="16"
            class="mr-0 mr-sm-50"
          />
          <span class="d-none d-sm-inline">Entry</span>
        </template>
        <tab-staff-entry
          :user-data="userData"
          class="mt-2 pt-75"
        />
      </b-tab>
      
            
    </b-tabs>
  </b-card>
</template>

<script>
import {
  BAlert, BLink, BCard, BRow, BCol, BForm, BFormGroup, flatPickr, BFormInput, BFormRadioGroup, BFormCheckboxGroup, BButton, BTab, BTabs,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import tabStaffPackage from './TabStaffPackage.vue'
import tabStaffEntry from './TabStaffEntry.vue'
import tabStaffCommission from './TabStaffCommission.vue'
import Snapshot from './SidebarSnapshot.vue'
import tabStaffSession from './TabStaffSession.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'
import EasyCamera from 'easy-vue-camera'

export default {
  components: {
    ToastificationContent,
    tabStaffPackage,
    tabStaffCommission,
     'v-easy-camera': EasyCamera,
    tabStaffEntry,
    tabStaffSession,
    vSelect,
    BForm,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BButton,
    Snapshot,
    BRow,
    BCol,
    BTab,
    BTabs,
    BCard,
    BAlert,
    BLink,
  },
  data() {
    return {
      client_module:JSON.parse(localStorage.getItem('userData')),
      centerOptions: [],
      isSnapShotSidebarActive:false,
      
      userData: {
        display_name: null,
        exsiting_username: null,
      },
      memberOptions:[],
      groupOptions:[],
      statusOptions: [
        { label: 'Active', value: 'active' },
        { label: 'Disabled', value: 'disabled' },
      ],
      roleOptions: [
        { label: 'Admin', value: 'admin' },
        { label: 'Manager', value: 'manager' },
        { label: 'Staff', value: 'staff' },
        { label: 'Senior PT', value: 'senior_pt' },
        { label: 'PT', value: 'pt' },
        { label: 'Rental PT', value: 'rental_pt' },
      ],
    }
  },
  created() {
        this.get_group_data()
    this.get_staff_data()
    this.get_center_data()
  },
  methods: {
    fetchOptions (search, loading) {
      setTimeout(() => {
      this.$http.get(process.env.VUE_APP_API_BASE+'/search/member/?string='+search)
            .then(res => {
              this.memberOptions = res.data
            })
            }, 200);
      },
         snapshot2() {
      this.isSnapShotSidebarActive = true
    },
    send_qr_code() {
       this.$http.post(process.env.VUE_APP_API_BASE+`/staff/${this.userData.uuid}/send_qr_code/`)
        .then(res => {
          if (res.data.result === true) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    update_card() {
         localStorage.setItem('reader_action', 'update_user_card')
         localStorage.setItem('user_id', this.userData.user_id)
         this.$swal({
          title: 'Please Scan NFC Card',
          icon: 'info',
          allowOutsideClick: false,
          confirmButtonText: this.$t('Cancel'),
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            localStorage.setItem('reader_action', 'normal')
            localStorage.removeItem('user_id')
          }
        })
    },
        one() {
      this.isSnapShotSidebarActive = false
      this.get_staff_data()
    },
    go() {
        window.location = 'https://www.cloudgates.pro/snapshot.php?type=user&token='+this.userData.token
    },
    save_staff() {
      this.$http.post(process.env.VUE_APP_API_BASE+`/staff/${this.userData.user_id}/`, this.userData)
        .then(res => {
          if (res.data.result === true) {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                variant: 'success',
                text: res.data.message,
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
    get_center_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/centers/')
        .then(res => {
          this.centerOptions = res.data.centers
        })
    },
    get_group_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+'/groups/')
        .then(res => {
          this.groupOptions = res.data.groups
        })
    },
    reset_password() {
      this.$http.post(process.env.VUE_APP_API_BASE+`/staff/reset_password/${router.currentRoute.params.id}/`)
        .then(res => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-center',
            props: {
              title: res.data.message,
              icon: 'XIcon',
              variant: 'information',
            },
          })
        })
    },
    get_staff_data() {
      this.$http.get(process.env.VUE_APP_API_BASE+`/staff/${router.currentRoute.params.id}/`)
        .then(res => {
          this.userData = res.data
        })
    },
  },
}
</script>

<style>

</style>
